/* eslint-disable max-lines-per-function */
import { Button, Icon, Tooltip } from '@equinor/eds-core-react';
import { add as ADD } from '@equinor/eds-icons';
import {
  ComputeCaseDto,
  ComputeMethod,
  ComputeType,
} from '../../api/generated';
import { useIsOwnerOrAdmin } from '../../hooks/useIsOwnerOrAdmin';

export const AddCaseButtons = ({
  title,
  localList,
  addCase,
  isVariogramExhausted,
  isVariogramAvailabilityReady = true,
}: {
  title: string;
  localList?: ComputeCaseDto[];
  addCase?: (methodType: ComputeMethod, computeType: ComputeType) => void;
  isVariogramExhausted?: boolean;
  isVariogramAvailabilityReady?: boolean;
}) => {
  const isOwnerOrAdmin = useIsOwnerOrAdmin();
  const variogramMethods: string[] = [
    ComputeMethod.INDICATOR,
    ComputeMethod.NET_TO_GROSS,
    ComputeMethod.CONTINIOUS_PARAMETER,
  ];
  if (!addCase || !variogramMethods.includes(title)) return null;

  const method = title as ComputeMethod;
  return (
    <Tooltip
      title={
        !isVariogramAvailabilityReady
          ? 'Loading available variogram combinations'
          : isVariogramExhausted
          ? 'All variogram combinations for this variogram type are already created'
          : ''
      }
    >
      <Button
        variant="ghost"
        onClick={() => addCase(method, ComputeType.VARIOGRAM)}
        disabled={
          !isVariogramAvailabilityReady ||
          isVariogramExhausted ||
          localList?.some((item) => item.computeMethod === method) ||
          !isOwnerOrAdmin
        }
      >
        <Icon data={ADD} size={18}></Icon>
        Add case
      </Button>
    </Tooltip>
  );
};
